const PAGE_LABELS = { dashboard: 'DASHBOARD', lessons: 'LESSONS', quiz: 'QUIZ' };

export default function Topbar({ activePage, apiKey, onKeyClick, onStartLesson }) {
  return (
    <header className="topbar">
      <div className="breadcrumb">
        PILOTPATH / <span>{PAGE_LABELS[activePage] || activePage.toUpperCase()}</span>
      </div>
      <div className="topbar-right">
        {/* <div className="streak">🔥 7-day streak</div> */}
        <button
          className={`key-btn ${apiKey ? 'set' : ''}`}
          onClick={onKeyClick}
        >
          {apiKey ? '🔑 KEY SET' : '🔑 API KEY'}
        </button>
        {/* <button className="cta-btn" onClick={onStartLesson}>
          START LESSON →
        </button> */}
      </div>
    </header>
  );
}
